module.exports = __webpack_public_path__ + "img/welcome.30416d99.png";